import { ICopyable } from '../controls/common/icopyable';
import { IAttributeOrder } from './interfaces/attribute-order.interface';

export class AttributeOrder implements IAttributeOrder, ICopyable<AttributeOrder> {
    public id: number = null;
    public organizationId: string = null;
    public order: number = null;
    public attributeId: number = null;

    public createCopy(): AttributeOrder {
        const instance = new AttributeOrder();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.order = this.order;
        instance.attributeId = this.attributeId;

        return instance;
    }

    public static createFormCopy(attribute: AttributeOrder): IAttributeOrder {
        const instance = new AttributeOrder();
        instance.id = attribute.id;
        instance.organizationId = attribute.organizationId;
        instance.order = attribute.order;
        instance.attributeId = attribute.attributeId;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.order = other.order;
        this.attributeId = other.attributeId;
    }

    /**
     * Retourne une instance de AttributeOrder à partir d'une instance de IAttributeOrder.
     * @param other : Instance de IAttributeOrder.
     * @returns : Instance de AttributeOrder.
     */
    public static from(other: IAttributeOrder) {
        if (!!other) {
            const instance = new AttributeOrder();

            instance.id = other.id;
            instance.attributeId = other.attributeId;
            instance.order = other.order;
            instance.organizationId = other.organizationId;

            return instance;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.id}`;
    }
}
